<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-05-06 11:48:13
 * @LastEditors: zouyuping
 * @LastEditTime: 
 * @FilePath: 
 * @Description: 拼桌确认页面
-->
<template>
  <div class="share_table_con">
    <div class="share_table_tip">
      <p>当前餐桌有客人正在就餐</p>
      <p>请问是否拼桌？</p>
    </div>

    <div class="share_table_tab">
      <div class="trapezoid_con left_con">
        <img src="@/assets/images/share-table-left.png" alt="" />
        <div>
          <p>我们</p>
          <p>一起的</p>
        </div>
      </div>
      <div class="trapezoid_con right_con">
        <img src="@/assets/images/share-table-right.png" alt="" />
        <div>
          <p>我要</p>
          <p>拼桌</p>
        </div>
      </div>
    </div>
    <div class="share_tips_con">
      <p class="share_tips">同伴所点餐品互相可见，还可以请客买单哦！</p>
      <p class="share_tips">若餐桌没人，可此处反馈 <span>餐桌没人哦</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareTable",
  props: {},
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.share_table_con {
  padding: 32px;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  .share_table_tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 90px 0 80px;
    p {
      margin-bottom: 10px;
      font-size: 32px;
    }
  }
  .share_table_tab {
    display: flex;
    color: #ac8c5c;
    font-size: 36px;
    .trapezoid_con {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
      p {
        margin-bottom: 10px;
      }
    }
    .left_con {
      flex: 1;

      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        // background: #fff;
        // border-radius: 15px 15px 0 0;
        border-radius: 17px;
        box-shadow: 4px 9px 4px 0px rgba(212, 212, 212, 0.5),
          -6px 0px 4px 0px rgba(200, 200, 200, 0.5);
        transform: perspective(10px) scale(1.1, 1.3) rotateX(-1deg);
        transform-origin: top left;
        // z-index: -1;
      }
    }
    .right_con {
      width: 290px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        // background: #fff;
        // border-radius: 15px 15px 0 0;
        border-radius: 17px;
        box-shadow: 4px 1px 4px 0px rgba(212, 212, 212, 0.5),
          -6px 0px 4px 0px rgba(200, 200, 200, 0.5);
        transform: perspective(10px) scale(0.75, 0.63) rotateX(1deg);
        transform-origin: top right;
        // z-index: -1;
      }
    }
    img {
      width: 80px;
      height: 80px;
      margin-right: 32px;
    }
  }
  .share_tips_con {
    margin-top: 40px;
  }
  .share_tips {
    color: #999;
    margin: 20px 0;
    font-size: 24px;
    span {
      color: #ac8c5c;
      text-decoration: underline;
    }
  }
}
</style>
